import gql from 'graphql-tag';

export default gql`
query getDocumentsList($workspaceId: UUID!) {
  workspace(workspaceId: $workspaceId) {
    id
    competencyDocuments {
      edges {
        node {
          id
          title
        }
      }
    }
  }
}
`;
